export default [
  'Afghanistan',
  'Ägypten',
  'Albanien',
  'Algerien',
  'Andorra',
  'Angola',
  'Antigua und Barbuda',
  'Äquatorialguinea',
  'Argentinien',
  'Armenien',
  'Aserbaidschan',
  'Äthiopien',
  'Australien',
  'Bahamas',
  'Bahrain',
  'Bangladesch',
  'Barbados',
  'Belarus',
  'Belgien',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivien',
  'Bosnien und Herzegowina',
  'Botsuana',
  'Brasilien',
  'Britische Überseegebiete (Vereinigtes Königreich)',
  'Brunei Darussalam',
  'Bulgarien',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Chile',
  'China',
  'Costa Rica',
  'Côte d\'Ivoire',
  'Dänemark',
  'Deutschland',
  'Dominica',
  'Dominikanische Republik',
  'Dschibuti',
  'Ecuador',
  'El Salvador',
  'Eritrea',
  'Estland',
  'Eswatini',
  'Fidschi',
  'Finnland',
  'Frankreich',
  'Französische Überseegebiete',
  'Gabun',
  'Gambia',
  'Georgien',
  'Ghana',
  'Grenada',
  'Griechenland',
  'Grönland',
  'Großbritannien',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hongkong (China)',
  'Indien',
  'Indonesien',
  'Irak',
  'Iran',
  'Irland',
  'Island',
  'Israel',
  'Italien',
  'Jamaika',
  'Japan',
  'Jemen',
  'Jordanien',
  'Kambodscha',
  'Kamerun',
  'Kanada',
  'Kap Verde',
  'Kasachstan',
  'Katar',
  'Kenia',
  'Kirgisistan',
  'Kiribati',
  'Kolumbien',
  'Komoren',
  'Kongo',
  'Kongo - Demokratische Republik',
  'Korea - Demokratische Volksrepublik',
  'Korea - Republik',
  'Kosovo',
  'Kroatien',
  'Kuba',
  'Kuwait',
  'Laos',
  'Lesotho',
  'Lettland',
  'Libanon',
  'Liberia',
  'Libyen',
  'Liechtenstein',
  'Litauen',
  'Luxemburg',
  'Macao (China)',
  'Madagaskar',
  'Malawi',
  'Malaysia',
  'Malediven',
  'Mali',
  'Malta',
  'Marokko',
  'Marshallinseln',
  'Mauretanien',
  'Mauritius',
  'Mexiko',
  'Mikronesien',
  'Moldau',
  'Monaco',
  'Mongolei',
  'Montenegro',
  'Mosambik',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Neukaledonien',
  'Neuseeland',
  'Nicaragua',
  'Niederlande',
  'Niederländische Überseegebiete',
  'Niger',
  'Nigeria',
  'Nordmazedonien',
  'Norwegen',
  'Oman',
  'Österreich',
  'Pakistan ',
  'Palästina ',
  'Palau ',
  'Panama ',
  'Papua-Neuguinea ',
  'Paraguay ',
  'Peru ',
  'Philippinen ',
  'Polen ',
  'Portugal ',
  'Puerto Rico (USA)',
  'Ruanda ',
  'Rumänien ',
  'Russische Föderation',
  'Salomonen ',
  'Sambia ',
  'Samoa ',
  'San Marino ',
  'São Tomé und Príncipe ',
  'Saudi-Arabien ',
  'Schweden ',
  'Schweiz ',
  'Senegal ',
  'Serbien ',
  'Seychellen ',
  'Sierra Leone ',
  'Simbabwe ',
  'Singapur ',
  'Slowakei ',
  'Slowenien ',
  'Somalia ',
  'Spanien ',
  'Sri Lanka ',
  'St. Kitts und Nevis ',
  'St. Lucia ',
  'St. Vincent und die Grenadinen ',
  'Südafrika ',
  'Sudan ',
  'Südsudan ',
  'Suriname ',
  'Syrien ',
  'Tadschikistan ',
  'Taiwan (Chinesisches Taipei) ',
  'Tansania ',
  'Thailand ',
  'Timor-Leste ',
  'Togo ',
  'Tonga ',
  'Trinidad und Tobago ',
  'Tschad ',
  'Tschechische Republik ',
  'Tunesien ',
  'Türkei ',
  'Turkmenistan ',
  'Tuvalu ',
  'Uganda ',
  'Ukraine ',
  'Ungarn ',
  'Uruguay ',
  'USA ',
  'Usbekistan ',
  'Vanuatu ',
  'Vatikanstadt ',
  'Venezuela ',
  'Vereinigte Arabische Emirate ',
  'Vereinigtes Königreich ',
  'Vereinigte Staaten ',
  'Vietnam ',
  'Zentralafrikanische Republik ',
  'Zypern'
]
